<script setup>
import _groupBy from "lodash/groupBy";
import _map from "lodash/map";
import { models as textModels, getProvider as getTextProvider, getGroup as getTextGroup } from "@Utils/text-models";
import { models as imagesModels, getProvider as getImageProvider, getGroup as getImageGroup } from "@Utils/image-models";
import { useI18n } from "vue-i18n";
import _cloneDeep from "lodash/cloneDeep";
import { FormModelListbox } from "@Components/Form";

defineModel("models");

const { t: __ } = useI18n();

const textModelsGroups = _map(_groupBy(_cloneDeep(textModels), "group"), (items, group) => {
    return {
        name: getTextGroup(group).name,
        items: items,
    };
});

const imagesModelsGroups = [
    {
        name: __("Aucune image"),
        items: [
            {
                name: __("Désactiver la génération d'image"),
                id: null,
            },
        ],
    },
    ..._map(_groupBy(_cloneDeep(imagesModels), "group"), (items, group) => {
        return {
            name: getImageGroup(group).name,
            items: items,
        };
    }),
];
</script>

<template>
    <div class="grid gap-3 lg:grid-cols-1">
        <FormModelListbox v-model="models.text" :groups="textModelsGroups" required :label="__('Modèle de texte IA')">
            <template v-slot:details="{ item }">
                <div class="flex flex-col gap-3 p-3">
                    <div>
                        <span class="text-xs text-gray-600 dark:text-gray-400">{{ getTextProvider(item.provider).name }}&nbsp;/&nbsp;</span>
                        <span class="text-xs text-gray-900 dark:text-white">{{ item.name }}</span>
                    </div>
                    <div v-if="item.description" class="w-[14rem] text-xs text-gray-600 dark:text-gray-400">{{ item.description }}</div>
                    <div v-if="item.quality">
                        <span class="text-xs text-gray-900 dark:text-white">{{ __("Qualité") }}</span>
                        <div class="w-[14rem] grid grid-cols-10 gap-1 mt-1">
                            <div
                                v-for="i in 10"
                                :key="i"
                                :class="i <= item.quality ? 'bg-gray-900 dark:bg-white' : 'bg-gray-300 dark:bg-gray-800'"
                                class="h-1 rounded-full"></div>
                        </div>
                    </div>
                    <div v-if="item.speed">
                        <span class="text-xs text-gray-900 dark:text-white">{{ __("Vitesse") }}</span>
                        <div class="w-[14rem] grid grid-cols-10 gap-1 mt-1">
                            <div
                                v-for="i in 10"
                                :key="i"
                                :class="i <= item.speed ? 'bg-gray-900 dark:bg-white' : 'bg-gray-300 dark:bg-gray-800'"
                                class="h-1 rounded-full"></div>
                        </div>
                    </div>
                    <div v-if="item.price">
                        <span class="text-xs text-gray-900 dark:text-white">${{ item.price }}</span>
                        <span class="text-xs text-gray-600 dark:text-gray-400">&nbsp;/1M tokens</span>
                    </div>
                </div>
            </template>
        </FormModelListbox>
        <FormModelListbox v-model="models.image" :groups="imagesModelsGroups" required :label="__('Modèle d\'images')">
            <template v-slot:details="{ item }">
                <div class="flex flex-col gap-3 p-3">
                    <div>
                        <span class="text-xs text-gray-600 dark:text-gray-400">{{ getImageProvider(item.provider).name }}&nbsp;/&nbsp;</span>
                        <span class="text-xs text-gray-900 dark:text-white">{{ item.name }}</span>
                    </div>
                    <div v-if="item.description" class="w-[14rem] text-xs text-gray-600 dark:text-gray-400">{{ item.description }}</div>
                    <div v-if="item.quality">
                        <span class="text-xs text-gray-900 dark:text-white">{{ __("Qualité") }}</span>
                        <div class="w-[14rem] grid grid-cols-10 gap-1 mt-1">
                            <div
                                v-for="i in 10"
                                :key="i"
                                :class="i <= item.quality ? 'bg-gray-900 dark:bg-white' : 'bg-gray-300 dark:bg-gray-800'"
                                class="h-1 rounded-full"></div>
                        </div>
                    </div>
                    <div v-if="item.speed">
                        <span class="text-xs text-gray-900 dark:text-white">{{ __("Vitesse") }}</span>
                        <div class="w-[14rem] grid grid-cols-10 gap-1 mt-1">
                            <div
                                v-for="i in 10"
                                :key="i"
                                :class="i <= item.speed ? 'bg-gray-900 dark:bg-white' : 'bg-gray-300 dark:bg-gray-800'"
                                class="h-1 rounded-full"></div>
                        </div>
                    </div>
                    <div v-if="item.price">
                        <span class="text-xs text-gray-900 dark:text-white">${{ item.price }}</span>
                        <span class="text-xs text-gray-600 dark:text-gray-400">&nbsp;/image</span>
                    </div>
                </div>
            </template>
        </FormModelListbox>
    </div>
</template>
